<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapname2">Notes to the Reader</h2>
<p class="hanging"><span class="hang">1.</span> Due to the size and format of this series of books the author will concentrate on the gun tank versions of the vehicles described in the text. What is not covered will be those vehicles converted to support-based versions such as bridge-layers, self-propelled artillery, command and control vehicles, recovery vehicles, antiaircraft vehicles, etc.</p>
<p class="hanging"><span class="hang">2.</span> Prior to the Second World War and during the conflict armies generally classified their tanks as light, medium or heavy, based on the weight of the tank. Some armies also classified them by their missions. Each country’s system was unique, sometimes arbitrary and in some cases was changed during the course of the war. What one army might classify as a light tank would be considered a medium tank by another army or vice versa.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// teil3_1.vue?295953a3